module.exports = __webpack_public_path__ + "static/media/materializecss-logo.0df3ec68.png";